import { render, staticRenderFns } from "./RiskAversionDialog.vue?vue&type=template&id=7505f428&scoped=true"
import script from "./RiskAversionDialog.vue?vue&type=script&lang=js"
export * from "./RiskAversionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7505f428",
  null
  
)

export default component.exports